import BulkScriptsResource from "./bulkScripts.resource";

const bulkScriptsModule = angular
  .module("app.resources.bulkScripts", [])
  .service("BulkScripts", BulkScriptsResource);

export default bulkScriptsModule;



// WEBPACK FOOTER //
// ./src/resources/bulkScripts/bulkScripts.module.js